module.exports = __webpack_public_path__ + "img/aeon.f6145689.svg";